export enum ScriptNamesEnum {
    FOR_INITIAL_PAGE = 'forInitalPage',
    FOR_THANK_YOU_PAGE = 'forThankYouPage'
}
